import { useContext } from 'react';
import { ErrorsContext } from '../context/errors-context';

export function useError() {
  const error = useContext(ErrorsContext);
  return error;
}

export default useError;
